export const PUBLIC_ROUTES = {
  LOGIN: '/login',
  RESET_PASSWORD: '/reset-password',
} as const;